import { Component, Input, OnInit } from '@angular/core';

import { OpenLRExtendedPoint } from 'app/models/openlr';
import { CbmInputStyle } from 'app/shared/input/cbm-input-style';

@Component({
  selector: 'point-details-openlr',
  templateUrl: './point-details-openlr.component.html',
  styleUrls: ['./point-details-openlr.component.scss']
})
export class PointDetailsOpenlrComponent implements OnInit {
  @Input() id: string;
  @Input() inputStyle: CbmInputStyle;
  @Input() openlr: OpenLRExtendedPoint;

  public locationReferencePoints: any[];

  public labels: string[] = [
    'SITERECORD.OPENLR.LOCATIONREFERENCEPOINT',
    'SITERECORD.OPENLR.LASTLOCATIONREFERENCEPOINT'
  ];

  constructor() {}

  ngOnInit(): void {
    this.locationReferencePoints = [];
    this.locationReferencePoints[0] =
      this.openlr.openlrPointLocationReference.openlrPointAlongLine.openlrLocationReferencePoint;
    this.locationReferencePoints[1] =
      this.openlr.openlrPointLocationReference.openlrPointAlongLine.openlrLastLocationReferencePoint;
  }
}



// WEBPACK FOOTER //
// ./src/app/shared/point-details/openlr/point-details-openlr.component.ts